export const noPendingChangesObject = () => (
    {
        insert: {
            settingsGroups: [],
            customSettingTypes: []
        },
        update: {
            settingsGroups: [],
            settings: [],
            customSettingTypes: [],
            customSettingTypeValues: []
        },
        delete: {
            settingsGroups: [],
            settings: [],
            customSettingTypes: [],
            customSettingTypeValues: []
        }
    }
);

export const defaultSettingTypes = [
    {
        _id: '1',
        name: "string"
    },
    {
        _id: '2',
        name: "boolean"
    },
    {
        _id: '3',
        name: "number"
    },
    {
        _id: '4',
        name: "array"
    }
];

export const booleanValues = [
    {
        _id: '1',
        name: 'true'
    },
    {
        _id: '2',
        name: 'false'
    }
];

export const newId = () => `TEMP_ID_${(new Date()).getTime().toString(36) + Math.random().toString(36).slice(2)}`;